import { render, staticRenderFns } from "./axis-default.md?vue&type=template&id=7a83c933&"
import script from "./axis-default.md?vue&type=script&lang=js&"
export * from "./axis-default.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a83c933')) {
      api.createRecord('7a83c933', component.options)
    } else {
      api.reload('7a83c933', component.options)
    }
    module.hot.accept("./axis-default.md?vue&type=template&id=7a83c933&", function () {
      api.rerender('7a83c933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/plugin/axis/axis-default.md"
export default component.exports